import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "registration-culture" };
const _hoisted_2 = { class: "registration-culture__header" };
const _hoisted_3 = { class: "registration-culture__modal__icon" };
const _hoisted_4 = ["src"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { class: "dialog registration-culture__modal__buttons" };
const _hoisted_8 = ["src"];
import { reactive, onMounted, onBeforeUnmount } from 'vue';
import RegistrationCultureIndicators from '@/features/RegistrationCulture/components/RegistrationCultureIndicators.vue';
import RegistrationCultureChart from '@/features/RegistrationCulture/components/RegistrationCultureChart.vue';
import RegistrationCultureTable from '@/features/RegistrationCulture/components/RegistrationCultureTable.vue';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import bus from '@/helpers/events/bus';
import { useMixpanelConfig } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegistrationCulture',
    setup(__props) {
        const state = reactive({
            showModal: false,
            loadingExport: false,
        });
        const openModal = () => {
            useMixpanelConfig('view_oto-registration-culture_open-modal_oto-ai');
            state.showModal = true;
        };
        onMounted(() => {
            useMixpanelConfig('view_oto-registration-culture');
            bus.$on('render-page-loader', isActive => {
                state.loadingExport = isActive;
            });
        });
        onBeforeUnmount(() => {
            bus.$off('render-page-loader');
        });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('registration-culture.title')), 1),
                    _createVNode(_component_el_dialog, {
                        modelValue: state.showModal,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((state.showModal) = $event)),
                        "close-on-press-escape": false,
                        width: "550",
                        center: "",
                        class: "registration-culture__modal"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("img", {
                                    class: "icon",
                                    src: require(`@/assets/img/icons/stars-2.svg`)
                                }, null, 8, _hoisted_4)
                            ]),
                            _createElementVNode("strong", {
                                innerHTML: _ctx.$t('registration-culture.modal.title'),
                                class: "registration-culture__modal__title"
                            }, null, 8, _hoisted_5),
                            _createElementVNode("p", {
                                innerHTML: _ctx.$t('registration-culture.modal.text'),
                                class: "registration-culture__modal__text"
                            }, null, 8, _hoisted_6),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("button", {
                                    class: "btn btn-primary",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (state.showModal = false))
                                }, "Entendi")
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: openModal
                    }, [
                        _createElementVNode("img", {
                            class: "icon",
                            src: require(`@/assets/img/icons/stars.svg`)
                        }, null, 8, _hoisted_8),
                        _createTextVNode(" Oto IA ")
                    ])
                ]),
                _createVNode(RegistrationCultureIndicators),
                _createVNode(RegistrationCultureChart, {
                    title: _ctx.$t('registration-culture.charts.first.title'),
                    typeMetrics: "identified_orders"
                }, null, 8, ["title"]),
                _createVNode(RegistrationCultureChart, {
                    title: _ctx.$t('registration-culture.charts.second.title'),
                    description: _ctx.$t('registration-culture.charts.second.description'),
                    typeMetrics: "orders_identified_field"
                }, null, 8, ["title", "description"]),
                _createVNode(RegistrationCultureTable),
                _withDirectives(_createVNode(BaseLoader, {
                    color: "colored-block",
                    class: "render-loader"
                }, null, 512), [
                    [_vShow, state.loadingExport]
                ])
            ]));
        };
    }
});
